// extracted by mini-css-extract-plugin
export default {"header":"Nav_header__+qHEk","background":"Nav_background__-ZBld","logo":"Nav_logo__pU476","menu":"Nav_menu__dFIiZ"};